<!-- Loading -->
<div class="bio-loading" *ngIf="carregando">
  <div class="spinner"></div>
</div>

<!-- Erro / 404 -->
<div class="bio-error" *ngIf="!carregando && erro">
  <div class="error-content">
    <i class="fas fa-exclamation-circle"></i>
    <h2>Página não encontrada</h2>
    <p>A página Bio que você está procurando não existe ou foi desativada.</p>
    <a href="/" class="btn-voltar">Voltar ao início</a>
  </div>
</div>

<!-- Bio Page -->
<div class="bio-desktop-wrapper" *ngIf="!carregando && !erro && bioPagina">
<div class="bio-page"
     [style.backgroundColor]="bioPagina.corFundo || '#FFF8F0'"
     [style.fontFamily]="obtenhaFamiliaFonte()"
     [ngClass]="{'heatmap-ativo': modoHeatmap}">

  <!-- HEADER -->
  <header class="bio-header">
    <!-- Logo -->
    <div class="bio-logo-container">
      <img *ngIf="bioPagina.urlLogo"
           [src]="'/images/empresa/' + bioPagina.urlLogo"
           [alt]="bioPagina.titulo"
           class="bio-logo" />
      <div *ngIf="!bioPagina.urlLogo" class="bio-logo-placeholder">
        <i class="fas fa-store"></i>
      </div>
    </div>

    <!-- Name -->
    <h1 class="bio-name" [style.color]="bioPagina.corTexto || '#333'">
      {{bioPagina.titulo}}
    </h1>

    <!-- Subtitle -->
    <p class="bio-subtitle" *ngIf="bioPagina.subtitulo"
       [style.color]="bioPagina.corSecundaria || '#666'">
      {{bioPagina.subtitulo}}
    </p>

    <!-- Address -->
    <p class="bio-address" *ngIf="bioPagina.empresa?.descricaoEndereco || bioPagina.empresa?.endereco"
       [style.color]="bioPagina.corSecundaria || '#666'">
      <i class="fas fa-map-marker-alt"></i>
      {{bioPagina.empresa.descricaoEndereco || bioPagina.empresa.endereco}}
    </p>

    <!-- Status badge -->
    <div class="bio-status" *ngIf="bioPagina.empresa">
      <span class="status-badge"
            [ngClass]="{'aberto': statusLoja.aberto, 'fechado': !statusLoja.aberto}"
            [style.borderRadius.px]="bioPagina.borderRadius">
        <span class="status-dot"></span>
        {{statusLoja.texto}}
      </span>
      <span class="pedido-minimo" *ngIf="bioPagina.empresa?.pedidoMinimo > 0">
        Pedido mínimo R$ {{bioPagina.empresa.pedidoMinimo | number:'1.2-2'}}
      </span>
    </div>
  </header>

  <!-- OFFERS CAROUSEL -->
  <section class="bio-ofertas" *ngIf="bioPagina.exibirOfertas !== false && ofertasAtivas.length > 0">
    <div class="ofertas-header">
      <h3 class="ofertas-titulo" [style.color]="bioPagina.corTexto || '#333'">
        Ofertas do Cardápio
      </h3>
      <span class="ofertas-counter" *ngIf="!exibeOfertasEmLista && totalOfertas > 1">
        {{ofertaAtual + 1}}/{{totalOfertas}}
      </span>
    </div>

    <div class="ofertas-carousel"
         *ngIf="!exibeOfertasEmLista"
         [style.borderRadius.px]="bioPagina.borderRadius"
         (touchstart)="onTouchStart($event)"
         (touchend)="onTouchEnd($event)">
      <div class="ofertas-track"
           [style.transform]="'translateX(-' + (ofertaAtual * 100) + '%)'">
        <div class="oferta-slide" *ngFor="let oferta of ofertasAtivas; let i = index">
          <div class="oferta-card" (click)="registrarClique('oferta', oferta.id, oferta.urlAcao, oferta.titulo, i)"
               [attr.data-heatmap]="'oferta_' + oferta.id"
               [style.backgroundColor]="bioPagina.corFundoCard || '#FFFFFF'"
               [style.borderRadius.px]="bioPagina.borderRadius">
            <div class="oferta-thumb" *ngIf="oferta.urlImagem">
              <img [src]="'/images/empresa/' + oferta.urlImagem" [alt]="oferta.titulo" loading="lazy" />
              <span class="oferta-badge" *ngIf="oferta.textoBadge">{{oferta.textoBadge}}</span>
            </div>
            <div class="oferta-info">
              <h4 class="oferta-nome" [style.color]="bioPagina.corTexto || '#333'">{{oferta.titulo}}</h4>
              <p class="oferta-descricao" *ngIf="oferta.descricao"
                 [style.color]="bioPagina.corSecundaria || '#666'">{{oferta.descricao}}</p>
              <div class="oferta-precos">
                <span class="preco-novo">
                  R$ {{oferta.precoPromocional | number:'1.2-2'}}
                </span>
                <span class="preco-antigo" *ngIf="oferta.precoOriginal">
                  R$ {{oferta.precoOriginal | number:'1.2-2'}}
                </span>
              </div>
              <button class="oferta-btn-pedir"
                      (click)="registrarClique('oferta', oferta.id, oferta.urlAcao, oferta.titulo, i); $event.stopPropagation()"
                      [style.backgroundColor]="bioPagina.corBotaoCta || bioPagina.corPrimaria || '#E53935'"
                      [style.borderRadius.px]="bioPagina.borderRadius">
                <i class="fas fa-shopping-bag"></i> Pedir Agora
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ofertas-lista" *ngIf="exibeOfertasEmLista">
      <div class="oferta-card oferta-card--lista"
           *ngFor="let oferta of ofertasAtivas; let i = index"
           (click)="registrarClique('oferta', oferta.id, oferta.urlAcao, oferta.titulo, i)"
           [attr.data-heatmap]="'oferta_' + oferta.id"
           [style.backgroundColor]="bioPagina.corFundoCard || '#FFFFFF'"
           [style.borderRadius.px]="bioPagina.borderRadius">
        <div class="oferta-thumb" *ngIf="oferta.urlImagem">
          <img [src]="'/images/empresa/' + oferta.urlImagem" [alt]="oferta.titulo" loading="lazy" />
          <span class="oferta-badge" *ngIf="oferta.textoBadge">{{oferta.textoBadge}}</span>
        </div>
        <div class="oferta-info">
          <h4 class="oferta-nome" [style.color]="bioPagina.corTexto || '#333'">{{oferta.titulo}}</h4>
          <p class="oferta-descricao" *ngIf="oferta.descricao"
             [style.color]="bioPagina.corSecundaria || '#666'">{{oferta.descricao}}</p>
          <div class="oferta-precos">
            <span class="preco-novo">
              R$ {{oferta.precoPromocional | number:'1.2-2'}}
            </span>
            <span class="preco-antigo" *ngIf="oferta.precoOriginal">
              R$ {{oferta.precoOriginal | number:'1.2-2'}}
            </span>
          </div>
          <button class="oferta-btn-pedir"
                  (click)="registrarClique('oferta', oferta.id, oferta.urlAcao, oferta.titulo, i); $event.stopPropagation()"
                  [style.backgroundColor]="bioPagina.corBotaoCta || bioPagina.corPrimaria || '#E53935'"
                  [style.borderRadius.px]="bioPagina.borderRadius">
            <i class="fas fa-shopping-bag"></i> Pedir Agora
          </button>
        </div>
      </div>
    </div>

    <!-- Dots -->
    <div class="ofertas-dots" *ngIf="!exibeOfertasEmLista && totalOfertas > 1">
      <span *ngFor="let oferta of ofertasAtivas; let i = index"
            class="dot"
            [ngClass]="{'active': i === ofertaAtual}"
            (click)="irParaOferta(i)">
        <span class="dot-progress" *ngIf="i === ofertaAtual && timerAutoPlay"></span>
      </span>
    </div>
  </section>

  <!-- PROMO BADGE -->
  <div class="bio-promo-badge" *ngIf="bioPagina.textoBadgePromocional">
    <span class="promo-text">{{bioPagina.textoBadgePromocional}}</span>
  </div>

  <!-- LINKS -->
  <section class="bio-links" *ngIf="itensBioAtivos.length > 0">
    <div *ngFor="let item of itensBioAtivos">
      <div class="link-wrapper" *ngIf="!isSeparator(item)">
        <div class="link-etiqueta" *ngIf="item.etiqueta && !modoHeatmap"
             [style.backgroundColor]="bioPagina.corBotaoCta || bioPagina.corPrimaria || '#E53935'">
          <i class="fas fa-tag"></i> {{item.etiqueta}}
        </div>
        <a class="link-card"
           [ngClass]="{'link-cta': ehLinkCta(item)}"
           [class.link-card--disabled]="!obtenhaHrefDoLink(item)"
           [attr.data-heatmap]="'link_' + item.id"
           [attr.href]="obtenhaHrefDoLink(item) || null"
           [attr.target]="abreLinkEmNovaAba(item) ? '_blank' : null"
           [attr.rel]="obtenhaRelLink(item)"
           [attr.aria-label]="obtenhaAriaLabelLink(item)"
           [attr.aria-disabled]="obtenhaHrefDoLink(item) ? null : 'true'"
           (click)="onClickLink($event, item)"
           [style.borderColor]="ehLinkCta(item) ? (obtenhaCorDoLink(item) || bioPagina.corPrimaria || '#E53935') : null"
           [style.backgroundColor]="bioPagina.corFundoCard || '#FFFFFF'"
           [style.borderRadius.px]="bioPagina.borderRadius">
          <div class="link-thumb-wrapper"
               *ngIf="temThumbNoLink(item)"
               [ngClass]="{'link-thumb-wrapper--cta': ehLinkCta(item)}">
            <img [src]="obtenhaUrlThumb(item)" class="link-thumb" alt="" loading="lazy" />
          </div>
          <div class="link-icon-wrapper"
               *ngIf="!temThumbNoLink(item)"
               [ngClass]="{'cta-icon': ehLinkCta(item)}"
               [style.backgroundColor]="ehLinkCta(item) ? ((obtenhaCorDoLink(item) || bioPagina.corPrimaria || '#E53935') + '15') : ((obtenhaCorDoLink(item) || bioPagina.corPrimaria || '#455A64') + '15')">
            <img *ngIf="obtenhaImagemDoIcone(item)"
                 [src]="obtenhaImagemDoIcone(item)"
                 class="link-icon-image"
                 alt=""
                 loading="lazy" />
            <i *ngIf="!obtenhaImagemDoIcone(item)"
               [class]="obtenhaIconeDoLink(item)"
               [style.color]="obtenhaCorDoLink(item) || (ehLinkCta(item) ? (bioPagina.corPrimaria || '#E53935') : obtenhaCorDecorativaDoLink(item))"></i>
          </div>
          <div class="link-content">
            <strong class="link-title"
                    [style.color]="obtenhaCorDoLink(item) || (ehLinkCta(item) ? (bioPagina.corPrimaria || '#E53935') : (bioPagina.corTexto || '#333'))">
              {{item.titulo}}
            </strong>
            <span class="link-subtitle" *ngIf="item.subtitulo"
                  [style.color]="obtenhaCorDoSubtituloDoLink(item) || (ehLinkCta(item) ? (obtenhaCorDoLink(item) || bioPagina.corPrimaria || '#E53935') : (bioPagina.corSecundaria || '#666'))">
              <strong *ngIf="ehLinkCta(item)">{{item.subtitulo}}</strong>
              <ng-container *ngIf="!ehLinkCta(item)">{{item.subtitulo}}</ng-container>
            </span>
          </div>
          <i class="fas fa-chevron-right link-chevron"
             [style.color]="ehLinkCta(item) ? (obtenhaCorDoLink(item) || bioPagina.corPrimaria || '#E53935') : null"></i>
        </a>
      </div>

      <div class="bio-separator" *ngIf="isSeparator(item)">
        <div class="bio-separator__line" *ngIf="item.separatorShowLine !== false"></div>
        <span class="bio-separator__text"
              *ngIf="item.separatorText"
              [style.backgroundColor]="bioPagina.corFundo || '#FFF8F0'"
              [style.color]="bioPagina.corSecundaria || '#666'">
          {{item.separatorText}}
        </span>
      </div>
    </div>
  </section>

  <!-- Heatmap Layer -->
  <ng-container *ngIf="modoHeatmap && indicadoresHeatmap.length > 0">
    <div class="heatmap-camada">
      <div class="heatmap-item"
           *ngFor="let item of indicadoresHeatmap"
           [style.top.px]="item.top"
           [style.left.px]="item.left"
           [style.width.px]="item.width"
           [style.height.px]="item.height"
           [style.backgroundColor]="item.cor"
           [style.borderRadius.px]="item.borderRadius"
           [ngClass]="{'heatmap-top': item.eTopClique}">
        <span class="heatmap-badge" *ngIf="item.quantidade > 0"
              [ngClass]="{'heatmap-badge-top': item.eTopClique}">
          {{item.quantidade}} {{item.quantidade === 1 ? 'clique' : 'cliques'}} · {{item.percentual}}%
        </span>
      </div>
    </div>
  </ng-container>

  <!-- FOOTER -->
  <footer class="bio-footer">
    <!-- Horários -->
    <div class="horarios-toggle" (click)="toggleHorarios(); registrarClique('horarios', 0, '', 'Horários de Funcionamento')"
         *ngIf="bioPagina.empresa?.horariosDoServico?.length" [attr.data-heatmap]="'horarios_0'">
      <i class="fas fa-info-circle mr-2"></i>
      Ver horários de funcionamento
      <i class="fas ml-2" [ngClass]="{'fa-chevron-down': !horariosExpandido, 'fa-chevron-up': horariosExpandido}"></i>
    </div>

    <div class="horarios-tabela" *ngIf="horariosExpandido && bioPagina.empresa?.horariosDoServico"
         [style.backgroundColor]="bioPagina.corFundoCard || '#FFFFFF'"
         [style.borderRadius.px]="bioPagina.borderRadius">
      <div class="horario-linha" *ngFor="let horario of bioPagina.empresa.horariosDoServico">
        <span class="horario-dia">{{horario.servico || horario.dia}}</span>
        <span class="horario-valor">{{horario.descricaoHorario || horario.horario || 'Fechado'}}</span>
      </div>
    </div>

    <!-- Powered by -->
    <div class="bio-powered-by">
      <a href="https://meucardapio.ai" target="_blank" rel="noopener noreferrer">
        Feito com <span class="heart">&#10084;</span> por MeuCardapio.ai
      </a>
    </div>
  </footer>
</div>
</div>
